import React from 'react';

/**
 * https://reactjs.org/docs/context.html
 * React context global store.
 */
class HelperGlobalDataStore {

	/**
	 * Глобална променлива, използвана за debug.
	 *
	 */
	dataDebug = {};

	constructor() {
		/**
		 * Mimics private property.
		 * Данните (JSON обекти) трябва да се задават през setter и да не са публично достъпни.
		 * Не трябва да се update-ва inner данните директно.
		 */
		let p_data = {};

		/**
		 * Mimics private property.
		 * Обект с references към React компонентите.
		 */
		let p_objs = {};

		this.forceUpdate = (key) => {
			if (!key) {
				throw '[bindObj] key: property not set';
			}
			if (typeof key !== 'string') {
				throw 'key: expected string';
			}
			if (p_objs[key].length) {
				p_objs[key].map((item) => {
					item.forceUpdate();
				})
			}
		}

		this.bindObj = (key, object) => {
			if (!key) {
				throw '[bindObj] key: property not set';
			}
			if (typeof key !== 'string') {
				throw 'key: expected string';
			}
			if (object == null) {
				p_objs[key] = []; // unbind
			} else {
				if (p_objs[key]) {
					p_objs[key].push(object)
				} else {
					p_objs[key] = [object];
				}
			}
		}

		/**
		 * Getter.
		 * @return: Data by Key (if key is set) or all data (if not set).
		 */
		this.get = (key = null) => {
			if (key) {
				return p_data[key];
			} else {
				return p_data;
			}
		}
		/**
		 * Getter.
		 * @return: Data by Key (if key is set) or all data (if not set).
		 */
		this.obj = (key = null) => {
			return p_objs[key];
		}

		/**
		 * Setter (entire dataset)
		 */
		this.init = (data) => {
			p_data = {...p_data, ...data};
			/**
			 * Само за dev mode, за debug.
			 */
			if (process.env.NODE_ENV == 'development') {
				this.dataDebug = {...p_data};
			}
		}

		/**
		 * Setter (key/value)
		 */
		this.set = (key, data) => {
			if (!key) {
				throw '[set] key: property not set';
			}
			if (typeof key !== 'string') {
				throw 'key: expected string';
			}
			p_data[key] = data;

			/**
			 * Само за dev mode, за debug.
			 */
			if (process.env.NODE_ENV == 'development') {
				this.dataDebug = {...p_data};
			}
		}
	}
}

export const ContextDataStore = React.createContext(new HelperGlobalDataStore());

